import { useState, useEffect } from 'react';
import '../dashboard/css/core.css';
import '../dashboard/css/theme-default.css';
import '../dashboard/css/demo.css';
import '../dashboard/libs/perfect-scrollbar/perfect-scrollbar.css';
import '../dashboard/libs/apex-charts/apex-charts.css';
import '../dashboard/js/helpers';
import '../dashboard/js/config';
import '../dashboard/fonts/boxicons.css';
import '../dashboard/css/icons.css';
import '../dashboard/menuisidebar.css';
import avatar from '../dashboard/img/avatars/1.png';
import icone from '../dashboard/img/icons/brands/icon_person.png';
import LocalStorage from '../../helpers/localstorage';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setupAPIclient } from '../../services/setupAPIclient';
import PhoneInput from 'react-phone-input-2';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BsBoxArrowRight, BsUpload, BsPerson, BsBell, BsBarChart, BsClockHistory } from "react-icons/bs";
import { BiMenu, BiX } from "react-icons/bi";
import { FiAward } from 'react-icons/fi';
import { formatDate } from 'date-fns';
import AIAssistant from '../AIAssistant';
import { motion } from 'framer-motion';
import ThemeToggle from '../common/ThemeToggle';

interface LayoutProps {
  children: React.ReactNode;
}

const MOBILE_BREAKPOINT = 992;

type Country = {
  name: string;
  code: string;
  flag: string;
};

const LayoutSubmasterToUser: React.FC<LayoutProps> = ({ children }) => {

  const localStorage = new LocalStorage();
  const navigate = useNavigate();
  const location = useLocation();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );
  const [showModalUpdateSubmaster, setShowModalUpdateSubmaster] = useState(false);
  //const [isPermissionGranted, setPermissionGranted] = useState(false);

  const [isCadastroOpen, setCadastroOpen] = useState(false);
  const [isContractOpen, setContractOpen] = useState(false);

  const [preview, setPreview] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number_phone: "",
    password:"",
    can_edit:false,
    can_view: false

  });
  const isAgendaRoute = location.pathname === "/AgendaPageSubmaster";

  // Toggle lateral menu
  const toggleMenu = () => setIsCollapsed(!isCollapsed);
  const closeMobileMenu = () => {
    if (isMobile) {
      setIsCollapsed(true);
    }
  };

  // Logout
  const logout = () => {
    localStorage.removeAuthTokenUserToSubmaster();
    navigate("/");
  };

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  // Handle file selection
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if(file){
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result as string);
      reader.readAsDataURL(file);
    } else {
      setSelectedFile(null);
      setPreview(null);
    }
  };


  // Fetch user data
  const handleGetDataUser = async () => {
    try{
      const token = String(localStorage.getAuthTokenUserToSubmaster());
      const ApiClient = setupAPIclient(token);
      const response = await ApiClient.post("/auth/get/loginUserToSubmaster");

      console.log(` valor de logs ---  === == == = == = ${response.data}`)


      setFormData(prev => ({...prev, ...response.data}));
    } catch(error){ console.error(error); }
  };

  // Submit update
  /*const handleSubmitUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    const requiredFields = ["name", "email", "number_phone"];
    for (const field of requiredFields) {
      if (!String(formData[field]).trim()) {
        toast.error(`O campo ${field} é obrigatório!`, { autoClose: 2000 });
        return;
      }
    }
    const token = String(localStorage.getAuthTokenUserToSubmaster());
    const ApiClient = setupAPIclient(token);
    const toastId = toast.loading("Atualizando dados...");
    try {

      if(formData.password === ""){
      const response = await ApiClient.post("/auth/register/update/loginUserToSubmaster", {
            email: formData.email,
            name: formData.name,
            number_phone: formData.number_phone,
          });
      }else {
  const response = await ApiClient.post("/auth/register/update/loginUserToSubmaster", {
        email: formData.email,
        name: formData.name,
        number_phone: formData.number_phone,
        password:formData.password
      });
      }
    

      // Aqui tratamos o retorno da API
      const data = response.data;

      if (data.error) {
        toast.update(toastId, {
          render: data.message,
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        toast.update(toastId, {
          render: data.message,
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
      }
    } catch (error: any) {
      // Em caso de erro na requisição
      let message = "Erro ao atualizar os dados";
      if (error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
      }
      toast.update(toastId, {
        render: message,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };*/
  const handleSubmitUpdate = async (e) => {
  e.preventDefault();

  const token = String(localStorage.getAuthTokenUserToSubmaster());
  const ApiClient = setupAPIclient(token);
  const toastId = toast.loading("Atualizando dados...");

  try {
    // Se o usuário quiser alterar apenas a senha
    if (formData.password && formData.password.trim() !== "") {
      const response = await ApiClient.post("/auth/register/update/loginUserToSubmaster", {
        password: formData.password,
      });

      const data = response.data;
      toast.update(toastId, {
        render: data.message || "Senha atualizada com sucesso!",
        type: data.error ? "error" : "success",
        isLoading: false,
        autoClose: 2000,
      });
      return;
    }

    // Se quiser alterar nome, email ou telefone
    const requiredFields = ["name", "email", "number_phone"];
    for (const field of requiredFields) {
      if (!String(formData[field]).trim()) {
        toast.error(`O campo ${field} é obrigatório!`, { autoClose: 2000 });
        toast.dismiss(toastId);
        return;
      }
    }

    const response = await ApiClient.post("/auth/register/update/loginUserToSubmaster", {
      email: formData.email,
      name: formData.name,
      number_phone: formData.number_phone,
    });

    const data = response.data;
    toast.update(toastId, {
      render: data.message || "Dados atualizados com sucesso!",
      type: data.error ? "error" : "success",
      isLoading: false,
      autoClose: 2000,
    });
  } catch (error) {
    let message = "Erro ao atualizar os dados";
    if (error.response?.data?.message) {
      message = error.response.data.message;
    }
    toast.update(toastId, {
      render: message,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
  }
};



  // ---------- Paleta de cores ----------
  const colors = {
    darkGray: "#7A7A7A",        
    
  };
    // ---------- Estilos Globais ----------
  const inputWrapperStyle = {
    display: "flex",
    alignItems: "center",
    border: `1px solid ${colors.darkGray}`,
    borderRadius: "10px",
    padding: "8px 12px",
    background: "#fff",
    gap: "10px",
  };
  const inputStyle = { border: "none", outline: "none", flex: 1, fontSize: "16px", color: colors.darkGray };


  useEffect(() => {
    handleGetDataUser();
  }, []);

  const dueDateNumber = Number(formData.due_date);
  const isPlanCanceled = !isNaN(dueDateNumber) && dueDateNumber < 0;
  const pageMetaByPath: Record<string, { title: string; subtitle: string }> = {
    "/HomeUserToSubmasterPage": { title: "Painel do Signatário", subtitle: "Acompanhe os contratos disponíveis para você." },
    "/UploadPageSubmaster": { title: "Upload de Contrato", subtitle: "Envie contratos conforme sua permissão de acesso." },
    "/SeeContractPageSubmaster": { title: "Contratos", subtitle: "Visualize status e detalhes dos documentos." },
    "/UserPageSubmaster": { title: "Usuários", subtitle: "Consulte o cadastro de usuários autorizados." },
    "/RegionFormSubmaster": { title: "Regiões", subtitle: "Visualize a organização por regiões." },
    "/UnitFormSubmaster": { title: "Unidades", subtitle: "Acompanhe as unidades vinculadas ao contrato." },
    "/CompanyPageSubmaster": { title: "Empresas", subtitle: "Veja as empresas e suas estruturas associadas." },
    "/NotificationPageSubmaster": { title: "Notificações", subtitle: "Gerencie alertas e mensagens automáticas." },
    "/ReportPageSubmaster": { title: "Relatórios", subtitle: "Analise dados operacionais e histórico." },
    "/AgendaPageSubmaster": { title: "Agenda", subtitle: "Visualização mensal da agenda de contratos." },
  };
  const currentPage = pageMetaByPath[location.pathname] || {
    title: "Área do Signatário",
    subtitle: "Fluxo intuitivo para acompanhamento contratual.",
  };
  const isRouteActive = (routes: string[]) => routes.includes(location.pathname);
  const contractRoutes = ["/UploadPageSubmaster", "/SeeContractPageSubmaster"];
  const cadastroRoutes = ["/UserPageSubmaster", "/RegionFormSubmaster", "/UnitFormSubmaster", "/CompanyPageSubmaster"];
  const contractActive = isRouteActive(contractRoutes);
  const cadastroActive = isRouteActive(cadastroRoutes);

  useEffect(() => {
    if (contractActive) setContractOpen(true);
    if (cadastroActive) setCadastroOpen(true);
  }, [contractActive, cadastroActive]);

  useEffect(() => {
    const handleResize = () => {
      const mobileView = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobileView);
      setIsCollapsed(mobileView);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setIsCollapsed(true);
    }
  }, [location.pathname, isMobile]);

  return (
    <div className="layout-wrapper layout-content-navbar centerLayout modern-shell" style={{ background: "#FFFFFF", color: "#222222" }}>
      <div className="layout-container">
        {isMobile && !isCollapsed && (
          <button
            type="button"
            className="modern-sidebar-backdrop"
            onClick={closeMobileMenu}
            aria-label="Fechar menu"
          />
        )}

        {/* Sidebar */}
        {!isCollapsed && (
          <aside
              className={`layout-menu menu-vertical d-flex flex-column modern-sidebar ${isMobile ? "modern-sidebar-mobile" : ""}`}
              style={{
                minHeight: "100vh",
                width: isCollapsed ? "70px" : "270px",
                transition: "width 0.3s",
                paddingTop: "1rem",
              }}
            >
          {/* Brand / Logo */}
          <div
            className="app-brand d-flex align-items-center justify-content-between px-3 mb-4"
            style={{ paddingBottom: "1rem" }}
          >
            {!isCollapsed && (
              <>
                <div className="d-flex align-items-center">
                  <img
                    src={icone}
                    className="rounded-circle modern-sidebar-avatar"
                    width={45}
                    height={45}
                    alt="Perfil"
                  />
                  <span className="ms-2 fw-bold" style={{ color: "#222222", fontSize: "1.1rem" }}>
                     {formData.name}
                  </span>
                </div>

                {isMobile && (
                  <button
                    type="button"
                    className="btn modern-sidebar-close"
                    onClick={closeMobileMenu}
                    aria-label="Fechar menu"
                  >
                    <BiX size={24} />
                  </button>
                )}
              </>
            )}
          </div>

          {/* Menu Items */}
          {formData.can_edit && formData.can_view && (
            <ul className="menu-inner list-unstyled px-2 modern-sidebar-nav">
                <li className="modern-nav-group-label">Principal</li>
                
                <li className="menu-item mb-1">
                  <Link
                    to="/HomeUserToSubmasterPage"
                    className={`menu-link modern-nav-link ${isRouteActive(["/HomeUserToSubmasterPage"]) ? "is-active" : ""}`}
                    title="Página inicial do sistema"
                    onClick={closeMobileMenu}
                  >
                    <span className="modern-nav-icon">
                      <BsBoxArrowRight color="rgb(93, 173, 226)" />
                    </span>
                    {!isCollapsed && <span className="modern-nav-text">Home</span>}
                  </Link>
                </li>

                {/** Contrato */}
                <li className="menu-item mb-1">
                  <div
                    onClick={() => setContractOpen(!isContractOpen)}
                    className={`menu-link modern-nav-trigger ${contractActive ? "is-active" : ""}`}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="modern-nav-icon">
                      <BsUpload color="rgb(93, 173, 226)" />
                    </span>
                    {!isCollapsed && <span className="modern-nav-text">Contratos</span>}
                  </div>

                  {isContractOpen && !isCollapsed && (
                    <ul className="submenu list-unstyled mt-1 modern-submenu">
                      <li>
                        <Link to="/UploadPageSubmaster" className={`modern-sub-link ${isRouteActive(["/UploadPageSubmaster"]) ? "is-active" : ""}`} onClick={closeMobileMenu}>
                          Upload contrato
                        </Link>
                      </li>
                      <li>
                        <Link to="/SeeContractPageSubmaster" className={`modern-sub-link ${isRouteActive(["/SeeContractPageSubmaster"]) ? "is-active" : ""}`} onClick={closeMobileMenu}>
                          Ver contratos
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                {/** Cadastro */}
                <li className="modern-nav-group-label">Gestão</li>
                <li className="menu-item mb-1">
                  <div
                    onClick={() => setCadastroOpen(!isCadastroOpen)}
                    className={`menu-link modern-nav-trigger ${cadastroActive ? "is-active" : ""}`}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="modern-nav-icon">
                      <BsPerson color="rgb(93, 173, 226)" />
                    </span>
                    {!isCollapsed && <span className="modern-nav-text">Cadastro</span>}
                  </div>

                  {isCadastroOpen && !isCollapsed && (
                    <ul className="submenu list-unstyled mt-1 modern-submenu">
                      <li><Link to="/UserPageSubmaster" className={`modern-sub-link ${isRouteActive(["/UserPageSubmaster"]) ? "is-active" : ""}`} onClick={closeMobileMenu}>Usuário</Link></li>
                      <li><Link to="/RegionFormSubmaster" className={`modern-sub-link ${isRouteActive(["/RegionFormSubmaster"]) ? "is-active" : ""}`} onClick={closeMobileMenu}>Região</Link></li>
                      <li><Link to="/UnitFormSubmaster" className={`modern-sub-link ${isRouteActive(["/UnitFormSubmaster"]) ? "is-active" : ""}`} onClick={closeMobileMenu}>Unidade</Link></li>

                      <li><Link to="/CompanyPageSubmaster" className={`modern-sub-link ${isRouteActive(["/CompanyPageSubmaster"]) ? "is-active" : ""}`} onClick={closeMobileMenu}>Empresa</Link></li>
                    </ul>
                  )}
                </li>

                {[
                  { to: "/NotificationPageSubmaster", icon: <BsBell color="rgb(93, 173, 226)" />, label: "Notificação" },
                  { to: "/ReportPageSubmaster", icon: <BsBarChart color="rgb(93, 173, 226)" />, label: "Relatórios" },
                  { to: "/AgendaPageSubmaster", icon: <BsClockHistory color="rgb(93, 173, 226)" />, label: "Agenda" },
                ].map((item, idx) => (
                  <li className="menu-item mb-1" key={idx}>
                    <Link
                      to={item.to}
                      className={`menu-link modern-nav-link ${isRouteActive([item.to]) ? "is-active" : ""}`}
                      onClick={closeMobileMenu}
                    >
                      <span className="modern-nav-icon">{item.icon}</span>
                      {!isCollapsed && <span className="modern-nav-text">{item.label}</span>}
                    </Link>
                  </li>
                ))}

            </ul>
          )}

          </aside>
        )}

        {/* Page Wrapper */}
        <div className="layout-page" style={{ background: "#FFFFFF" }}>
          {/* Navbar */}
         <nav
  className="ml-2 mr-2 mt-2 navbar navbar-expand-lg rounded-4 px-4 py-2 modern-navbar"
  style={{
    background: "#FFFFFF", // navbar branco primário
    color: "#222222",
    border: "1px solid #EDEDED"
  }}
>
  <div className="d-flex align-items-center flex-grow-1">
    <button
      className="btn me-3 rounded-circle p-2"
      onClick={toggleMenu}
      style={{
        minWidth: '45px',
        minHeight: '45px',
        background: "rgb(93, 173, 226)", // vermelho rosado primary (button)
        color: "#FFFFFF",
        border: "none",
        transition: "background 0.15s",
      }}
      aria-label={isCollapsed ? "Abrir menu" : "Ocultar menu"}
    >
      <BiMenu size={24} color="#FFFFFF" />
    </button>
  </div>

  <ul className="navbar-nav ms-auto d-flex align-items-center modern-navbar-actions">
    <li className="nav-item me-2 d-flex align-items-center modern-navbar-action-item">
      <ThemeToggle />
    </li>
    <li className="nav-item dropdown">
      <a
        className="nav-link dropdown-toggle d-flex align-items-center"
        data-bs-toggle="dropdown"
        href="#"
        style={{ color: "#222222" }}
      >
        <img
          src={icone}
          className="rounded-circle"
          style={{ border: "2px solid #EDEDED" }}
          width={45}
          height={45}
          alt="Perfil"
        />
      </a>
      <ul
        className="dropdown-menu dropdown-menu-end shadow rounded-3"
        style={{ background: "#FFFFFF", color: "#222222", border: "1px solid #EDEDED" }}
      >
        <li>
          <span className="dropdown-item-text fw-bold" style={{ color: "#222222" }}>
            {formData.name}
          </span>
        </li>
        <li>
          <button
            className="dropdown-item"
            onClick={() => setShowModalUpdateSubmaster(true)}
            style={{ color: "#222222", transition: "background 0.15s" }}
            onMouseEnter={e => (e.currentTarget.style.background = "rgba(74,144,226,0.06)")}
            onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
          >
            Editar Perfil
          </button>
        </li>
        <li>
          <button
            className="dropdown-item"
            onClick={logout}
            style={{ color: "#222222", transition: "background 0.15s" }}
            onMouseEnter={e => (e.currentTarget.style.background = "rgba(74,144,226,0.06)")}
            onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
          >
            Sair
          </button>
        </li>
      </ul>
    </li>
  </ul>
          </nav>

          <style jsx>{`
            .navbar {
              transition: all 0.3s ease;
            }

            .navbar .form-control:focus {
              box-shadow: 0 0 10px rgba(74,144,226,0.18);
              border-color: rgb(93, 173, 226);
            }

            .dropdown-menu {
              min-width: 200px;
            }

            .dropdown-item:hover {
              background-color: rgba(74,144,226,0.08);
              color: #222222;
            }
            .text-muted { color: #7A7A7A !important; }
          `}</style>

          {/* Content */}
          <div className={`content p-4 modern-content ${isAgendaRoute ? "agenda-full-content" : ""}`} style={{ background: "#FFFFFF" }}>
            {!isAgendaRoute && (
            <div className="modern-card p-4 mb-4" style={{ background: "linear-gradient(140deg, rgba(231,76,60,0.08), rgba(255,255,255,0.96))" }}>
              <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
                <div>
                  <h3 className="mb-1" style={{ color: "#1f2937" }}>{currentPage.title}</h3>
                  <p className="mb-0" style={{ color: "#6b7280" }}>{currentPage.subtitle}</p>
                </div>
                <div className="d-flex flex-wrap gap-2">
                  <Link className="btn btn-sm modern-primary-btn" to="/SeeContractPageSubmaster">Ver Contratos</Link>
                  <Link className="btn btn-sm btn-outline-danger" to="/NotificationPageSubmaster">Notificações</Link>
                </div>
              </div>
            </div>
            )}
           
          {!isAgendaRoute && (
          <div
            className="d-flex align-items-center rounded-3 shadow-sm p-3 mb-4"
            style={{
              backgroundColor: "#FFFFFF", // fundo branco para destacar
              border: "1px solid #EDEDED",
            }}
          >

              {/* NOVO: alerta para plano cancelado por pagamento devedor */}
              
            {/* Ícone em círculo colorido */}
            <div
              className="d-flex align-items-center justify-content-center rounded-circle me-3"
              style={{
                backgroundColor: "rgb(93, 173, 226)",
                width: "48px",
                height: "48px",
              }}
            >
              <FiAward size={24} color="#FFFFFF" />
            </div>

            {/* Texto */}
            <div>

                {
                
                  isPlanCanceled ? (
                    <div className="alert alert-danger d-flex align-items-center" role="alert">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      <div>
                        <strong>Plano cancelado:</strong>
                        existe um pagamento em atraso. O plano foi cancelado devido
                        a um débito pendente. Por favor, regularize o pagamento para reativar o plano.
                      </div>
                    </div>
                  ) :              
                 
                <div
                style={{
                  fontSize: "0.9rem",
                  color: "#7A7A7A",
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <span
                  style={{
                    fontWeight: 600,
                    color: "#4A4A4A",
                    fontSize: "0.95rem",
                  }}
                >
                  Acesso de usuário
                </span>

                {formData.can_edit && (
                  <span style={{ color: "rgb(93, 173, 226)", fontSize: "0.85rem" }}>
                    • Permissão para edição
                  </span>
                )}

                {formData.can_view && (
                  <span style={{ color: "rgb(72, 153, 206)", fontSize: "0.85rem" }}>
                    • Permissão para visualização
                  </span>
                )}
              </div>

                
                }
                

            
            </div>
          </div>
          )}


            <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.32, ease: 'easeOut' }}>{children}</motion.div>
          </div>

          {/* Footer */}
          <footer className="bg-light py-3 text-center modern-footer" style={{ background: "#F5F6FA", color: "#7A7A7A" }}>© 2025</footer>
        </div>
      </div>

        {/* Modal Editar Perfil */}
        {showModalUpdateSubmaster && (
          <div className="modal fade show d-block" tabIndex={-1}>
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content border-0 rounded-4 shadow-lg">

      {/* Cabeçalho */}
      <div
        className="modal-header rounded-top-4 d-flex align-items-center justify-content-between"
        style={{ background: "rgb(255, 125, 112)", color: "#FFFFFF" }}
      >
        <h5 className="modal-title d-flex align-items-center fw-bold" style={{color:"#FFFFFF"}}>
          <i className="bi bi-person-lines-fill me-2 animate__animated animate__fadeInLeft"></i>
          Editar Perfil
        </h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={() => setShowModalUpdateSubmaster(false)}
          aria-label="Fechar"
        />
      </div>

<div
            className="d-flex mt-2 ml-2 mr-2 align-items-center rounded-3 shadow-sm p-3 mb-4"
            style={{
              backgroundColor: "#FFFFFF", // fundo branco para destacar
              border: "1px solid #EDEDED",
            }}
          >
            {/* Ícone em círculo colorido */}
            <div
              className="d-flex align-items-center justify-content-center rounded-circle me-3"
              style={{
                backgroundColor: "rgb(93, 173, 226)",
                width: "48px",
                height: "48px",
              }}
            >
              <FiAward size={24} color="#FFFFFF" />
            </div>

            {/* Texto */}
            <div>
              <div style={{ fontSize: "0.9rem", color: "#7A7A7A" }}>Acesso de usuários</div>
              
            </div>
          </div>
  

      {/* Corpo */}
      <div className="modal-body p-4" style={{ background: "#FFFFFF" }}>
        <div className="d-flex flex-column flex-md-row align-items-center gap-4">

          {/* Avatar */}

        {/* Formulário */}
        <form className="flex-grow-1 row g-3" onSubmit={handleSubmitUpdate}>
          <div className="col-md-6">
            <label className="form-label fw-semibold d-flex align-items-center">
              <i className="bi bi-person me-2 animate__animated animate__fadeInLeft" style={{ color: "rgb(93, 173, 226)" }}></i> Nome
            </label>
            <input
              type="text"
              className="form-control shadow-sm"
              name="name"
              placeholder="Nome"
              value={formData.name}
              onChange={handleChange}
              style={{ borderColor: "#EDEDED" }}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label fw-semibold d-flex align-items-center">
              <i className="bi bi-envelope-at me-2 animate__animated animate__fadeInLeft" style={{ color: "rgb(93, 173, 226)" }}></i> Email
            </label>
            <input
              type="email"
              className="form-control shadow-sm"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              style={{ borderColor: "#EDEDED" }}
            />
          </div>

          <div className="col-md-12">
            <label className="form-label fw-semibold d-flex align-items-center">
              <i className="bi bi-telephone me-2 animate__animated animate__fadeInLeft" style={{ color: "rgb(93, 173, 226)" }}></i> Telefone
            </label>
            <PhoneInput
              country={"br"}
              enableSearch
              value={formData.number_phone}
              onChange={(value) =>
                setFormData({ ...formData, number_phone: value })
              }
              inputProps={{
                name: "number_phone",
                className: "form-control shadow-sm",
                placeholder: "Número de telefone",
              }}
              inputStyle={{
                width: "100%",
                fontSize: "16px",
                backgroundColor: "#F5F6FA",
                height: "45px",
                border: "1px solid #EDEDED"
              }}
            />
          </div>

          {/* Campo de senha opcional */}
          <div className="col-md-12">
            <label className="form-label fw-semibold d-flex align-items-center">
              <i className="bi bi-lock me-2 animate__animated animate__fadeInLeft" style={{ color: "rgb(93, 173, 226)" }}></i> Nova senha (opcional)
            </label>
            <input
              type="password"
              className="form-control shadow-sm"
              name="password"
              placeholder="Digite a nova senha se quiser alterar"
              value={formData.password || ""}
              onChange={handleChange}
              style={{ borderColor: "#EDEDED" }}
            />
          </div>
        </form>


        </div>
      </div>

      {/* Rodapé */}
      <div className="modal-footer rounded-bottom-4 d-flex justify-content-end" 
      style={{ background: "#FFFFFF", borderTop: "1px solid #EDEDED" }}>
        <button
          className="btn d-flex align-items-center me-2 btn btn-secondary"
          onClick={() => setShowModalUpdateSubmaster(false)}
        >
          <i className="bi bi-x-circle me-2 animate__animated animate__fadeIn"></i> Fechar
        </button>
          <button
            className="btn d-flex align-items-center"
            onClick={handleSubmitUpdate}
            style={{
              backgroundColor: "rgb(93, 173, 226)",
              color: "#FFFFFF",
              border: "none",
              transition: "background 0.15s",
            }}
            onMouseLeave={e => (e.currentTarget.style.background = "rgb(93, 173, 226)")}
          >
          <i className="bi bi-save me-2 animate__animated animate__pulse"></i> Salvar Alterações
          </button>
      </div>
    </div>
  </div>
</div>

        )}

      {/* ASSISTENTE IA GLOBAL */}
      <AIAssistant />
              
    </div>
  );
};

export default LayoutSubmasterToUser;
